/**
 * Umfrage (Poll) – Frontend Submit Logic
 *
 * Reads the API endpoint from a data-endpoint attribute on the
 * .mail-poll-container element so no inline PHP→JS injection is needed.
 */

if (typeof window.submitZggPoll !== 'function') {
    window.submitZggPoll = async function (e, answer) {
        const container = e.target.closest('.mail-poll-container');
        const buttons = container.querySelectorAll('.poll-btn');
        const feedback = container.querySelector('.poll-feedback');
        const pollButtonsContainer = container.querySelector('.poll-buttons');
        const successMsg = feedback.getAttribute('data-success-msg') || 'Erfolgreich gespeichert!';

        // Collect inputs
        const textInputs = container.querySelectorAll('.poll-input-text');
        const sliderInputs = container.querySelectorAll('.poll-input-slider');
        
        const answerLines = [];

        textInputs.forEach((textInput) => {
            const textInputValue = textInput.value.trim();
            if (!textInputValue) {
                return;
            }

            const textInputLabel = textInput.getAttribute('data-field-label') || 'Eingabe';
            answerLines.push(`${textInputLabel}: ${textInputValue}`);
        });

        if (answer) {
            answerLines.unshift(answer);
        }
        
        sliderInputs.forEach((sliderInput) => {
            const sliderVal = sliderInput.value;
            let sliderLabel = 'Slider';

            if (sliderInput.previousElementSibling) {
                const labelClone = sliderInput.previousElementSibling.cloneNode(true);
                labelClone.querySelectorAll('.poll-slider-val').forEach((valueLabel) => valueLabel.remove());
                sliderLabel = labelClone.textContent.trim() || sliderLabel;
            }

            answerLines.push(`${sliderLabel}: ${sliderVal}`);
        });

        const finalAnswer = answerLines.join('\n');

        buttons.forEach(btn => btn.disabled = true);
        textInputs.forEach(textInput => textInput.disabled = true);
        sliderInputs.forEach(sliderInput => sliderInput.disabled = true);

        if (pollButtonsContainer) {
            pollButtonsContainer.classList.add('poll-submitted');
        }
        
        feedback.className = 'poll-feedback';
        feedback.style.display = 'block';
        feedback.innerText = 'Wird gesendet...';
        feedback.style.color = '#dfc8e1';

        const endpoint = container.getAttribute('data-endpoint');

        try {
            const response = await fetch(endpoint, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                body: JSON.stringify({ answer: finalAnswer })
            });
            const data = await response.json();

            if (response.ok && data.status === 'success') {
                feedback.className = 'poll-feedback success';
                feedback.innerText = successMsg;
            } else {
                throw new Error(data.message || 'Serverfehler');
            }
        } catch (error) {
            feedback.className = 'poll-feedback error';
            feedback.innerText = 'Fehler beim Senden. Bitte später erneut versuchen.';
            buttons.forEach(btn => btn.disabled = false);
            textInputs.forEach(textInput => textInput.disabled = false);
            sliderInputs.forEach(sliderInput => sliderInput.disabled = false);
            if (pollButtonsContainer) {
                pollButtonsContainer.classList.remove('poll-submitted');
            }
        }
    }
}
